module.exports = __webpack_public_path__ + "img/zhineng_youtu.92c51413.png";